import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/omar/projects/mvp/mvp-website-new/layouts/default.vue").then(m => m.default || m))
}